export default __webpack_public_path__ + "static/media/complementary--bicycles-and-pedestrians-detour--g1.dcab8b13.png";